import React from 'react';
import '../../styles/dashboard.css';

const RecentSales = () => {
  const sales = []; // This would come from API

  return (
    <div className="recent-sales">
      <h3>Recent Sales</h3>
      {sales.length === 0 ? (
        <p className="no-data">No recent sales</p>
      ) : (
        <div className="sales-list">
          {sales.map(sale => (
            <div key={sale.id} className="sale-item">
              <span>{sale.invoice_number}</span>
              <span>{sale.amount}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentSales;